export { default as Discounts } from './Discounts';
